import api from "../../Hooks/axiosApi";

/**
 * The discovery call with a broking business owner.
 *
 * The existing discovery call is all property questions and none of it fits a
 * conversation with a broker about their own business. This is that one.
 */

export const getMbDiscoveryService = (leadId: number | string) => {
    return api.get(`/api/crm/mb-discovery/${leadId}`);
};

export const saveMbDiscoveryService = (body: any) => {
    return api.post(`/api/crm/mb-discovery`, body);
};
